import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import RestartAltRoundedIcon from '@mui/icons-material/RestartAltRounded';
import { useTheme } from '@mui/system';
import { Tooltip } from "@diana/core";
import { RESET_BUTTON_NS } from "./i18n";

interface ResetButtonProps {
  onResetAllClick: () => void;
  isDisabled?: boolean;
}

export const ResetButton = ({ onResetAllClick, isDisabled = false }: ResetButtonProps) => {
  const { t } = useTranslation([RESET_BUTTON_NS]);
  const { palette, breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down(700));

  return (
    <Tooltip
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      targetNode={
        <Button
          disabled={isDisabled}
          onClick={onResetAllClick}
          sx={{
            minWidth: isMobile ? '20px' : '56px',
            padding: isMobile ? '4px' : '7px',
            '&:hover': {
              backgroundColor: ({ palette }) => palette.action.hover,
            },
            color: isDisabled ? palette.text.disabled : palette.text.secondary,
          }}
        >
          <RestartAltRoundedIcon
            sx={{
              mr: '5px',
              color: isDisabled ? palette.text.disabled : palette.text.secondary,
            }}
            fontSize="small"
          />
          { isMobile ? null : <Typography sx={{ 'white-space': 'nowrap' }}>{t('components/ResetButton:resetAll')}</Typography> }
        </Button>
      }
    >
      <Box p={1}>
        <Typography>{t('components/ResetButton:youWillResetAllFilters')}</Typography>
      </Box>
    </Tooltip>
    );
};
